/**
 * OpenCallsSignup
 *
 * Form-creator (ajax with jquery): https://app.ungapped.com/Web/SubscriptionForms
 */
const OpenCallsSignup = {
  init: () => {
    // get elements
    const formEl = document.getElementById("block-open-calls-signup__form");
    const emailEl = document.getElementById("contactEmail");
    const doubleOptIdEl = document.getElementById("double-opt-id");
    const policyEl = document.getElementById("contactConsentText");
    const button = document.getElementById("block-open-calls-signup__submit");
    const responseDiv = document.getElementById("response");

    // submit
    if (formEl) {
      formEl.addEventListener("submit", (e) => {
        e.preventDefault();

        // get values
        let email = emailEl.value;
        let doubleOptId = doubleOptIdEl.value;
        let policy = policyEl.checked;

        if (!policy) {
          if (responseDiv)
            responseDiv.innerHTML = "Du måste godkänna villkoren";
        } else {
          OpenCallsSignup.ajaxRequest(email, doubleOptId);
        }
      });
    }
  },

  ajaxRequest: (email, doubleOptId) => {
    const $ = jQuery;
    const responseDiv = document.getElementById("response");

    $.ajax({
      type: "post",
      dataType: "json",
      url: "https://ui.ungpd.com/Api/Subscriptions/dd32c31b-4cd6-41e3-8ec3-d70d98d0b2e9/ajax",
      data: {
        ListIds: ["0da7bbde-8a38-4a5f-bfa0-370d2ad71299"],
        Contact: {
          Email: email,
        },
        ConsentText:
          "Jag vill få relevant information om utlysningar från Net Zero Industry till min inkorg. Net Zero Industry ska inte dela eller sälja mina personuppgifter. Jag kan avsluta prenumerationen när som helst.",
        DoubleOptIn: {
          Issue: { IssueId: doubleOptId },
        },
      },
      statusCode: {
        200: function (res) {
          console.log("success");

          var response =
            "Tack för din anmälan! Du får en bekräftelse till din inkorg som du behöver godkänna för att prenumerera på utlysningar.";
          responseDiv.innerHTML = response;
        },
        400: function (xhr, status, error) {
          console.log("400");
          const message = xhr.responseJSON.Message;
          console.log(message);
          // console.log(xhr);
          console.log(xhr.responseJSON);
          var response = "Något gick fel, försök igen.";

          if (message == "No contact information provided") {
            var response = "Vänligen ange din e-post.";
          } else if (message == "Invalid email") {
            var response = "Angiven e-post är felaktig. Försök igen.";
          } else if (message == "Subscription already exists") {
            var response = "Du prenumererar redan på utlysningar.";
          } else {
            var response = message;
          }

          responseDiv.innerHTML = response;
        },
      },
    });

    return false;
  },
};

export default OpenCallsSignup;
